module.exports = __webpack_public_path__ + "static/media/book_rumuz_ae_bekhudi_persian_6.5316d666.jpg";